import { render, staticRenderFns } from "./DashWestudyPartner.vue?vue&type=template&id=5cf6e147&scoped=true&"
import script from "./DashWestudyPartner.vue?vue&type=script&lang=js&"
export * from "./DashWestudyPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6e147",
  null
  
)

export default component.exports